export default "__VITE_ASSET__BsNg2LDf__"